import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RawPermissions } from 'src/app/shared/models/raw-permissions.model';
import { PermissionService } from 'src/app/shared/services/permission.service';

@Component({
  selector: 'company-dropdown',
  templateUrl: './company-dropdown.component.html',
  styleUrls: ['./company-dropdown.component.scss']
})
export class CompanyDropdownComponent implements OnInit {
  public companies: Array<string>;
  // public rawPermissions: Array<RawPermissions>;
  public rawPermissionsSubscription: Subscription;
  public isHidden: boolean = true;
  public initialCompany: string;

  @Input()
  public rawPermissions: Array<RawPermissions>;

  constructor(private permissions: PermissionService, private router: Router) {
  }

  ngOnInit() {
    if(this.rawPermissions) {
      this.companies = this.rawPermissions.map( el => el.companyName);
      this.initialCompany = this.companies[0];
    }
   }

  public setCompany(company) {
    const targetPerms = this.rawPermissions.filter( permissions => permissions.companyName === company)[0];
    this.permissions.setPermissions(this.rawPermissions, this.rawPermissions.indexOf(targetPerms));
    this.router.navigateByUrl(`/loan-image`);
  }
}
